import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'; // this is needed!
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { TranslateService, TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { NewmenuModule } from './newmenu/newmenu.module';
import { LayoutModule } from './layout/layout.module';
import { SharedModule } from './shared/shared.module';
import { RoutesModule } from './routes/routes.module';
import { JwtModule } from "@auth0/angular-jwt";
import { LoaderService } from './services/Common/loader.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpErrorInterceptor } from '../app/common/virtualpos-http-interceptor';
import { PoslayoutModule } from './POS/poslayout/poslayout.module';
import { WaitingLoaderComponent } from './routes/waiting-loader/waiting-loader.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { POSModule } from './POS/pos.module';
import { RouterModule } from '@angular/router';
import { PayModule } from './routes/PayOut/payoutmodule.module'
//import { MenuService } from './core/menu/menu.service';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { merchantReducer } from './store/reducers/auth.reducer';
import { MerchantEffects } from './store/effects/auth.effects';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { LayoutsModule } from './accounting/layout/layout.module';
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export function tokenGetter() {
  return localStorage.getItem("VirtualPOSToken");
}
export class ClickjackingInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    request = request.clone({
      setHeaders: {
        'X-Frame-Options': 'SAMEORIGIN'
      }
    });
    return next.handle(request);
  }
}

@NgModule({
  declarations: [
    AppComponent,
    WaitingLoaderComponent,
  ],
  imports: [
    POSModule,
    PayModule,
    PoslayoutModule,
    LayoutsModule,
    HttpClientModule,
    BrowserAnimationsModule, // required for ng2-tag-input
    CoreModule,
    LayoutModule,
    NewmenuModule,MatSnackBarModule,
    StoreModule.forRoot({ merchant: merchantReducer }),
    EffectsModule.forRoot([MerchantEffects]),
    BrowserModule,
    SharedModule.forRoot(),
    BsDropdownModule.forRoot(),
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule.forRoot(),
    JwtModule.forRoot({
      config: {
        tokenGetter: tokenGetter
      }
    }),

    RoutesModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    })
  ],
  providers: [{
    provide: HTTP_INTERCEPTORS,
    useClass: HttpErrorInterceptor,
    multi: true
  }, {
    provide: HTTP_INTERCEPTORS,
    useClass: ClickjackingInterceptor,
    multi: true
  }
  ],
  //  {provide: LocationStrategy, useClass: HashLocationStrategy}
  bootstrap: [AppComponent]
})
export class AppModule { }
